import { FormField, FormInput, FormSectionTitle } from '@practium/ui';
import {
	MIXTURE_SETTINGS_FIELDS,
	type MixtureSettingsField,
	type MixtureSettingsForm,
} from '../../constants/mixtures.constants';
import tabStyles from '../Tabs/TabPanel.module.css';
import styles from './MixturesPanel.module.css';

interface MixtureSettingsSectionProps {
	form: MixtureSettingsForm;
	errors: Record<string, string>;
	isView: boolean;
	onChange: (field: MixtureSettingsField, value: string) => void;
}

const FIRST_ROW_SIZE = 3;

export const MixtureSettingsSection = ({
	form,
	errors,
	isView,
	onChange,
}: MixtureSettingsSectionProps) => (
	<div className={tabStyles.section}>
		<FormSectionTitle>Informações das misturas</FormSectionTitle>
		<div className={styles.settingsGrid}>
			{MIXTURE_SETTINGS_FIELDS.map((field, index) => (
				<div
					key={field.key}
					className={index < FIRST_ROW_SIZE ? styles.settingsThird : styles.settingsHalf}
				>
					<FormField
						label={field.label}
						required={!isView && !('optional' in field)}
						error={isView ? undefined : errors[field.key]}
					>
						{isView ? (
							<span className={tabStyles.viewText}>
								{form[field.key] ? `${form[field.key]} ${field.unit}`.trim() : '—'}
							</span>
						) : (
							<FormInput
								type="number"
								min="0"
								step={field.key === 'desiredEventsPerMonth' ? '1' : '0.1'}
								value={form[field.key]}
								placeholder={field.placeholder}
								onChange={(event) => onChange(field.key, event.target.value)}
								suffix={field.unit || undefined}
								hasError={!!errors[field.key]}
							/>
						)}
					</FormField>
				</div>
			))}
		</div>
	</div>
);
